export default __webpack_public_path__ + "static/media/Isometric_Square_red.19dbf5cb.svg";